const FETCH_NO_USER = 'user/FETCH_NO_USER';
const FETCH_USER = 'user/FETCH';
const INIT_USER = 'user/INIT';

export default {
  FETCH_USER,
  FETCH_NO_USER,
  INIT_USER
};
